import { formatCurrency } from '@youniquellc/javascript-common/reusable-functions/currencyFormatter';

// Attach currency formatter helper function to the window so it can be used anywhere on the site.
window.utilities = window.utilities || {};
window.utilities.formatCurrency = formatCurrency;

// Attach the locale we want to use for currency formatting to the window.
// We have three places the locale could be stored, so we pull from the data-api-override-language first,
// from the data-api-user-language second if the locale is still empty,
// and from the data-api-website-language third if the locale is still empty,
// with a final default being 'en_US' if we couldn't find a value from any of those three.
window.phpVarsForJs = document.getElementById('phpVarsForJs');
window.localeForCurrency = 'en_US';
if (window.phpVarsForJs) {
    window.localeForCurrency = window.phpVarsForJs.getAttribute('data-api-override-language') || window.phpVarsForJs.getAttribute('data-api-user-language') || window.phpVarsForJs.getAttribute('data-api-website-language') || 'en_US';
}
